module.exports = __webpack_public_path__ + "img/2.9e18a72d.png";